import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Space, Spin } from "antd";
import { getCards } from "entities/card";
import { getProfile } from "entities/viewer";
import { useTranslation } from "react-i18next";
import { CardAttachButton } from "./card-attach-button";
import styles from "./index.module.scss";

export const CardAttachBlock = () => {
  const { t } = useTranslation();

  const { data: cards, isLoading } = useQuery({
    queryKey: ["cards"],
    queryFn: () => getCards(),
  });

  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: () => getProfile(),
  });

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 80,
        }}
      >
        <Spin />
      </div>
    );
  }

  if (!profile?.features?.wooppay_card_payouts) {
    return null;
  }

  if (cards?.data?.length !== 0) {
    return (
      <div className={styles.block}>
        <div className={styles.iconWrapper}>
          <ExclamationCircleOutlined />
        </div>
        <Space vertical size="middle">
          {t("cards.add_card_title")}
          <div className={styles.text}>{t("cards.add_card_description")}</div>
          <CardAttachButton />
        </Space>
      </div>
    );
  }

  return null;
};
